import React from 'react';

const Experience = () => {
  return (
    <section id="experience">
      <div className="section-header animate-fade-in-up">
        <span className="section-number">03.</span>
        <h2 className="section-title">Experience</h2>
        <div className="section-line"></div>
      </div>
      <div className="experience-content">
        <div className="job animate-fade-in-left delay-2">
          <h3 className="job-title animate-fade-in-up delay-3">Junior Software Engineer Intern <span className="job-company">@ SuPrazo Technologies</span></h3>
          <p className="job-date animate-fade-in-up delay-3">August 2025 - Present (Remote)</p>
          <ul className="job-description">
            <li className="animate-fade-in-up delay-4">Developed Python/Flask APIs for LLM-based interview intelligence, reducing latency by ~20%</li>
            <li className="animate-fade-in-up delay-4">Built multimodal pipelines (speech, facial expression, sentiment) for real-time interview evaluation</li>
            <li className="animate-fade-in-up delay-4">Collaborated with frontend engineers to integrate scoring dashboards and deliver end-to-end solutions</li>
            <li className="animate-fade-in-up delay-5">Wrote unit tests, logging, and participated in Git-based code reviews for reliability</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Experience;